// The top bar of the approved design: brand, the eight tabs, search (⌘K),
// the bell (components/Bell.tsx), the theme switch, Gazelle (⌘J) and the admin's avatar.
import type { ReactNode } from 'react';
import { S } from '../lib/strings';
import { initials } from '../lib/format';
import type { Theme } from '../lib/theme';
import { Flame, Ic, type IconName } from './Icon';
import { Wordmark } from './Wordmark';
import { TabInk } from './TabInk';
import { TopProgress } from './Busy';

export type Tab = 'ov' | 'live' | 'ord' | 'hh' | 'dev' | 'mk' | 'team' | 'fin';
export const TABS: [Tab, IconName][] = [['ov', 'grid'], ['live', 'map'], ['ord', 'list'], ['hh', 'house'], ['dev', 'chip'], ['mk', 'cyl'], ['team', 'users'], ['fin', 'wallet']];
export type { Theme };

interface Props {
  tab: Tab; onTab(t: Tab): void; alerts: number; theme: Theme; onTheme(): void;
  onSearch(): void; onGazelle(): void; bell: ReactNode; who: string;
}

export function Shell({ tab, onTab, alerts, theme, onTheme, onSearch, onGazelle, bell, who }: Props) {
  return (
    <header className="top">
      <TopProgress />
      <div className="bar">
        <div className="brand"><img src="./mygaz-icon.png" alt="" /><Wordmark /><span className="tag">Ops</span></div>
        <nav className="tabs inked" aria-label="Sections">
          <TabInk active={tab} />
          {TABS.map(([k, i]) => (
            <button key={k} className="tab" aria-current={tab === k ? 'page' : undefined} onClick={() => onTab(k)}>
              <Ic n={i} s="s" />{S.tabs[k]}
              {k === 'ov' && alerts > 0 && <span className="badge">{alerts}</span>}
              {k === 'live' && <span className="live" aria-label={S.live} />}
            </button>
          ))}
        </nav>
        <div className="acts">
          <button className="kbtn" aria-label={S.searchAria} onClick={onSearch}><Ic n="search" s="s" /><span className="t">{S.search}</span><kbd>⌘K</kbd></button>
          {bell}
          <button className="ibtn hide-s" aria-label={`${S.theme} : ${S.themeNames[theme]}`} onClick={onTheme}><Ic n={theme === 'light' ? 'sun' : theme === 'dark' ? 'moon' : 'auto'} s="s" /></button>
          <button className="gzbtn" aria-label={S.gazelleAria} onClick={onGazelle}><Flame /><span>{S.gazelle}</span></button>
          <span className="avatar" title={`${who} · ${S.admin}`}>{initials(who)}</span>
        </div>
      </div>
    </header>
  );
}
